const chatRequest = require('./chat-request')

export function getUsers(detail, callback) {
    const usersPrueba = [
        { id: 2, name: 'Andry Bracho', avatar: 'css/img/pic/person.svg', status: true },
        { id: 3, name: 'Soporte Wimzar', avatar: 'css/img/pic/person.svg', status: false },
        { id: 4, name: 'Cliente IVG', avatar: 'css/img/pic/person.svg', status: true }
    ]

    setTimeout(() => {
        callback(usersPrueba)
    }, 200)
}

export function getHistory(detail, callback) {

    chatRequest.start(detail, 'server/php/ia/ia-chat.php')
        .then((result) => {

            if (result) {
                return callback(result)
            }

        }).catch((error) => {
            console.error('Error de red en el chat', error)
            // snack.start({ act: "show", id: "updateError" })
        })
}

export function send(detail, callback) {
    chatRequest.start(detail, 'server/php/ia/ia-chat.php')
        .then((result) => {
            
            if (result) {
                return callback(result)
            }

        }).catch((error) => {
            console.error('Error de red en el chat', error)
            // snack.start({ act: "show", id: "updateError" })
        })
}